import React from "react";

function HashgraphDevHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  What is Hedera Hashgraph?
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Hedera Hashgraph is a public distributed ledger that uses a
                    hashgraph consensus algorithm, setting it apart from
                    traditional blockchain’s linear structure. Leveraging a
                    Directed Acyclic Graph (DAG), Hedera Hashgraph processes
                    transactions in parallel, allowing high-speed consensus and
                    efficiency.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HashgraphDevHero;
